module.exports = __webpack_public_path__ + "static/media/profile_2.343f88b3.jpg";